export const FETCH_PAYMENTS_HISTORY_START = 'FETCH_PAYMENTS_HISTORY_START';
export const FETCH_PAYMENTS_HISTORY_SUCCESS = 'FETCH_PAYMENTS_HISTORY_SUCCESS';
export const FETCH_PAYMENTS_HISTORY_FAILURE = 'FETCH_PAYMENTS_HISTORY_FAILURE';

export const FETCH_PAYMENTS_DETAILS_START = 'FETCH_PAYMENTS_DETAILS_START';
export const FETCH_PAYMENTS_DETAILS_SUCCESS = 'FETCH_PAYMENTS_DETAILS_SUCCESS';
export const FETCH_PAYMENTS_DETAILS_FAILURE = 'FETCH_PAYMENTS_DETAILS_FAILURE';

export const SET_PAYMENTS_DETAILS_START = 'SET_PAYMENTS_DETAILS_START';
export const SET_PAYMENTS_DETAILS_SUCCESS = 'SET_PAYMENTS_DETAILS_SUCCESS';
export const SET_PAYMENTS_DETAILS_FAILURE = 'SET_PAYMENTS_DETAILS_FAILURE';
